<template>
    <form-dialog ref="save-detail" title="编辑" :data="data" width="80%" :visible.sync="visibleSync" :columns="columnList" @confirm="SaveAs"></form-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `UseDeviceDetail`,
    props: {
        visible: { type: Boolean, default: () => false },
        data: { type: Object }
    },
    data() {
        return {
            title: `编辑`
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`]),
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        columnList() {
            return [{
                type: `string`,
                prop: `name`,
                readonly: true,
                label: `设备名称`,
                colspan: 12,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `table`,
                prop: `items`,
                label: `使用列表`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `string`,
                    prop: `biz_use_device_id`,
                    label: `biz_use_device_id`,
                    width: `10`,
                    isListable: false,
                    readonly: true
                }, {
                    type: `datetime`,
                    prop: `begin_time`,
                    label: `开始时间`,
                    width: `200`,
                    isListable: true,
                    readonly: false,
                    change: (that, { row }) => {
                        let min = this.difference(row.begin_time, row.end_time)
                        console.log(min)
                        this.$set(row, `use_time`, min)
                    }
                }, {
                    type: `datetime`,
                    prop: `end_time`,
                    label: `结束时间`,
                    width: `200`,
                    isListable: true,
                    readonly: false,
                    change: (that, { row }) => {
                        let min = this.difference(row.begin_time, row.end_time)
                        this.$set(row, `use_time`, min)
                    }
                }, {
                    type: `number`,
                    prop: `use_time`,
                    label: `使用时间`,
                    width: `160`,
                    isListable: true,
                    readonly: true,
                    default: 1
                }, {
                    type: `remoteselect`,
                    prop: `dic_worker_id`,
                    label: `负责人`,
                    isListable: true,
                    readonly: false,
                    // default: {
                    //     label: this.currentUser && this.currentUser.dic_worker_name,
                    //     value: this.currentUser && this.currentUser.dic_worker_id
                    // },
                    options: `/api/AcisSystem/Worker/SearchForKey`
                }],
                colspan: 24,
                default: []
            }]
        }
    },
    methods: {
        saveOne(row) {
            let that = this
            return new Promise((resolve, reject) => {
                if (that.data.biz_use_device_id == null) {
                    this.$message.error(`设备不能为空`)
                    return
                }
                // if (row.items == null || row.items.length == 0) {
                //     this.$message.error(`请添加明细！`)
                //     return
                // }
                row.items.forEach(d => {
                    if (d.use_time == null) {
                        this.$message.error(`使用时间不能为空`)
                        throw new Error(`EndIterative`)
                    } else if (d.begin_time == null) {
                        this.$message.error(`开始时间不能为空`)
                        throw new Error(`EndIterative`)
                    } else if (d.dic_worker_id == null) {
                        this.$message.error(`负责人不能为空`)
                        throw new Error(`EndIterative`)
                    }
                })
                let objs = _.map(row.items, d => {
                    return {
                        biz_use_device_id: that.data.biz_use_device_id,
                        use_time: d.use_time || 0,
                        begin_time: d.begin_time,
                        end_time: d.end_time,
                        dic_worker_id: d.dic_worker_id.value
                    }
                })
                console.log(objs)
                let req = this.myaxios.post(`/api/Nursing/UseDevice/PostUseDeviceDetail?biz_use_device_id=${that.data.biz_use_device_id}`, objs)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        SaveAs(row) {
            this.saveOne(row).then(data => {
                this.$emit(`save-success`)
                this.visibleSync = false
            })
        },
        difference: function(beginTime, endTime) {
            let minutesDiff = 0
            if (beginTime != null && endTime != null) {
                if (beginTime <= endTime) {
                    let dateBegin = this.$moment(beginTime || ``)
                    let dateEnd = this.$moment(endTime || ``)
                    minutesDiff = dateEnd.diff(dateBegin, `minutes`)
                }
            }
            return minutesDiff
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Device/UseDeviceDetail.vue